import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import {
  MatTableDataSource,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
} from '@angular/material/table';
import { PermissionsService } from 'src/app/services/permissions.service';
import { Department } from 'src/app/models/department.model';
import { UtilsService } from 'src/app/services/utils.service';
import { ApiService } from 'src/app/services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { AddDepartmentDialogComponent } from './add-department-dialog/add-department-dialog.component';
import { IndexTemplateComponent } from '@bisual/ngx-index-template';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatSuffix, MatPrefix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';

@Component({
  selector: 'app-departments',
  templateUrl: './departments.component.html',
  styleUrls: ['./departments.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatButton,
    MatIcon,
    FormsModule,
    ReactiveFormsModule,
    MatPaginator,
    MatFormField,
    MatInput,
    MatIconButton,
    MatSuffix,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    RouterLink,
    MatPrefix,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
  ],
})
export class DepartmentsComponent extends IndexTemplateComponent {
  permissions = inject(PermissionsService);
  private api = inject(ApiService);
  dialog = inject(MatDialog);

  protected readonly page_title = inject(ActivatedRoute).snapshot.title;

  displayedColumns: string[] = ['image', 'name', 'description', 'actions'];
  dataSource: MatTableDataSource<Department> = new MatTableDataSource<Department>();

  filterForm: UntypedFormGroup;

  constructor() {
    super(inject(Router), inject(UntypedFormBuilder), inject(ActivatedRoute), inject(UtilsService));
  }

  addDepartment() {
    const dialogRef = this.dialog.open(AddDepartmentDialogComponent, {
      width: '750px',
      data: {},
    });

    dialogRef.afterClosed().subscribe((department: Department) => {
      if (department != null) {
        this.api.createDepartment(department).subscribe(data => {
          this.fetchData();
        });
      }
    });
  }

  override fetchData() {
    this.api.getDepartmentsPaged(this.filterForm.value).subscribe(data => {
      this.dataSource.data = data.data;
      this.setMetadata(+data.meta.total, data.meta.current_page - 1, data.meta.per_page);
    });
  }
}
